import {App_Conf} from "../../core/app_conf";
import {MeetingStatus} from "./Meeting";
import {getReleaseToggles} from "../../ReleaseToggles/ReleaseToggleApiClient";
import {SpaConfigMeetingPortal} from "../../core/models/SpaConfig";

export type MeetingAuthenticatorResponse = {
    meetingName: string;
    fluidContainerId: string;
    fluidToken: string;
    communicationsIdentifier: string | null;
    meetingStatus: MeetingStatus;
}

const {
    MEETING_PORTAL_AUTHENTICATOR_FN_URL,
    MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS,
    SPA_CONFIG_MPA_INFO_URL_AKS,
    API_URL
} = App_Conf;

const defaultHeaders = {
    'Content-Type': 'application/json;charset=utf-8',
    'Access-Control-Allow-Origin': '*',
};

export const getMeetingDetails = async (
    meetingId: string,
    passcode: string,
    user: { id: string; name: string; },
    communicationsIdentifier?: string | null,
): Promise<MeetingAuthenticatorResponse> => {

    const releaseToggles = await getReleaseToggles();
    const url = new URL(
        releaseToggles.enableMeetingManagementRemote
            ? `${API_URL}${MEETING_PORTAL_AUTHENTICATOR_FN_URL_AKS}`
            : `${MEETING_PORTAL_AUTHENTICATOR_FN_URL}`
    );

    const response = await fetch(url!.toString(), {
        method: 'POST',
        headers: {
            ...defaultHeaders,
        },
        body: JSON.stringify({
            meetingId,
            passcode,
            user,
            communicationsIdentifier,
        }),
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}


export const getMeetingInfo = async (): Promise<SpaConfigMeetingPortal> => {
    const url = new URL(`${API_URL}${SPA_CONFIG_MPA_INFO_URL_AKS}`)

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
            ...defaultHeaders,
        }
    });
    if (response.ok) {
        return response.json();
    }
    throw response;
}

export const meetingPortalAuthenticatorClient = {
    getMeetingDetails: getMeetingDetails,
    getMeetingInfo
}